export const setWinner = (payload) => ({
  type: "SET_WINNER",
  payload,
});
export const setWinnerPhrase = (payload) => ({
  type: "SET_WINNER_PHRASE",
  payload,
});
export const setUserFrom = (payload) => ({
  type: "SET_USER_FROM",
  payload,
});
export const setIsModalOnline = (payload) => ({
  type: "SET_IS_MODAL_ONLINE",
  payload,
});
export const setIsModalWannaPlay = (payload) => ({
  type: "SET_IS_MODAL_WANNA_PLAY",
  payload,
});
export const setIsPlayingOnline = (payload) => ({
  type: "SET_IS_PLAYING_ONLINE",
  payload,
});
export const setComputerOption = (payload) => ({
  type: "SET_COMPUTER_OPTION",
  payload,
});
export const setUserOption = (payload) => ({
  type: "SET_USER_OPTION",
  payload,
});
export const setIsPlaying = (payload) => ({
  type: "SET_IS_PLAYING",
  payload,
});
export const setYou = (payload) => ({
  type: "SET_YOU",
  payload,
});
export const setIsModalRules = (payload) => ({
  type: "SET_IS_MODAL_RULES",
  payload,
});
export const setIsModalDashBoard = (payload) => ({
  type: "SET_IS_MODAL_DASH_BOARD",
  payload,
});
export const setIsPlus = (payload) => ({
  type: "SET_IS_PLUS",
  payload,
});
export const setIsLogged = (payload) => ({
  type: "SET_IS_LOGGED",
  payload,
});
export const setUsersOnline = (payload) => ({
  type: "SET_USERS_ONLINE",
  payload,
});
export const setLosed = (payload) => ({
  type: "SET_LOSED",
  payload,
});
export const setTied = (payload) => ({
  type: "SET_TIED",
  payload,
});
export const setScore = (payload) => ({
  type: "SET_SCORE",
  payload,
});
export const setRoom = (payload) => ({
  type: "SET_ROOM",
  payload,
});
